export const PAGE_TITLE = 'Form Preview';

export const PreviewType = {
  HTML: 'Html',
  PDF: 'Pdf',
  // TODO: remove HelloSign option after BE is updated
  HELLO_SIGN: 'HelloSign',
  SIGNING: 'Signing',
};

export const DEFAULT_BLOCK_NOTICE =
  'Generation blocked: this jurisdiction has no complete recording requirements. Review the notice and complete them on the Recording Requirements page.';
